import { Component } from '@angular/core';
import { NavParams, ViewController } from 'ionic-angular';
import { TranslateService } from '@ngx-translate/core';
import { Globals } from '../../../globals';
import { ReservationsServices } from '../../reservation/services';


/**
 * Generated class for the StockListPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-modal-extra-input',
    templateUrl: 'modal-extra-input.html',
})
export class ModalExtraInput {
    custom_field: any = {
        active: true,
        input_name: '',
        name: '',
        options: '',
        required: true,
        type: 'text'
    };
    update: boolean = false;
    array_options = [];

    constructor(public globals: Globals,
        public viewCtrl: ViewController,
        public translate: TranslateService,
        public navParams: NavParams,
        public reservationsServices: ReservationsServices) {
        if (this.navParams.get('input')) {
            this.custom_field = this.navParams.get('input');
            this.update = true;
            this.array_options = this.custom_field.options.split(';').slice(0, -1);
        }
    }

    close() {
        this.viewCtrl.dismiss();
    }

    save() {
        this.viewCtrl.dismiss(this.custom_field);
    }

    onChange(event) {
        this.custom_field.options = '';
        event.forEach(option => {
            this.custom_field.options += option + ';';
        });
    }
}


// WEBPACK FOOTER //
// ./src/pages/components/modal-extra-input/modal-extra-input.ts